﻿require('validation/validation');

console.log && console.log('Validation');